import CheckBox from '@app/components/CheckBox'
import CompanySelector from '@app/components/CompanySelector'
import EmailAddressList from '@app/components/EmailAddressList'
import PhoneNumberList from '@app/components/PhoneNumberList'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import { actionCreators, IQuickAddState } from '../modules/quickAdd'

type QuickAddModalProps = IQuickAddState & typeof actionCreators

export class QuickAddModal extends React.PureComponent<QuickAddModalProps> {
  private formRef: React.RefObject<HTMLFormElement>

  constructor(props: QuickAddModalProps) {
    super(props)

    this.formRef = React.createRef()

    bindFunctions(this)
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.closeQuickAdd}
        size='lg'
      >
        <ModalHeader toggle={this.props.closeQuickAdd}>
          Quick Add {this.props.contact.isCompany ? 'Company' : 'Connection'}
        </ModalHeader>
        <ModalBody>
          <form ref={this.formRef}>
            {!this.props.forceIsCompany && (
              <FormGroup>
                <CheckBox
                  onChange={this.props.setIsCompany}
                  value={this.props.contact.isCompany}
                >
                  Is Company
                </CheckBox>
              </FormGroup>
            )}
            {this.props.contact.isCompany
              ? this._renderCompanyQuickAdd()
              : this._renderConnectionQuickAdd()}
            <FormGroup>
              <Label>Phone Numbers</Label>
              <PhoneNumberList
                dataSource={this.props.contact.phoneNumbers}
                onChange={this.props.setPhoneNumbers}
              />
            </FormGroup>
            <FormGroup>
              <Label>Email Addresses</Label>
              <EmailAddressList
                dataSource={this.props.contact.emailAddresses}
                onChange={this.props.setEmailAddresses}
              />
            </FormGroup>
            {!this.props.contact.isValid && (
              <div className='text-danger white-space-pre'>
                {this.props.contact.error}
              </div>
            )}
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={this.props.closeQuickAdd} outline>
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button
            color='primary'
            disabled={!this.props.contact.isValid || this.props.isSaving}
            onClick={this._onSave}
          >
            <FontAwesomeIcon icon={['fal', 'save']} fixedWidth /> Save
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _onChangeFirstName(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setFirstName(event.target.value)
  }

  private _onChangeLastName(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setLastName(event.target.value)
  }

  private _onSave() {
    if (this.props.contact.isValid) {
      this.props.saveQuickAdd(this.props.contact)
    }
  }

  private _renderCompanyQuickAdd() {
    return (
      <div>
        <FormGroup>
          <Input
            autoFocus
            onChange={this._onChangeLastName}
            placeholder='Company name'
            value={this.props.contact.lastName}
            required
          />
        </FormGroup>
      </div>
    )
  }

  private _renderConnectionQuickAdd() {
    return (
      <div>
        <FormGroup>
          <Row>
            <Col md={6}>
              <Input
                autoFocus
                onChange={this._onChangeFirstName}
                placeholder='First name'
                value={this.props.contact.firstName}
              />
            </Col>
            <Col md={6}>
              <Input
                onChange={this._onChangeLastName}
                placeholder='Last name'
                value={this.props.contact.lastName}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <CompanySelector
            disableQuickAdd
            onChange={this.props.setCompany}
            value={this.props.contact.company}
          />
        </FormGroup>
      </div>
    )
  }
}
